import { Component, OnInit } from '@angular/core';
import { AlertController, LoadingController } from '@ionic/angular';
import { CertificationServiceServiceProxy, FarmerServiceServiceProxy } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.page.html',
  styleUrls: ['./admin.page.scss'],
})
export class AdminPage implements OnInit {

  constructor(
    public alertController: AlertController,
    public loadingController: LoadingController,
    private farmerSvc: FarmerServiceServiceProxy,
    private certificationService: CertificationServiceServiceProxy
  ) { }

  ngOnInit() {
  }

  async errorMissingFields() {
    const alert = await this.alertController.create({
      header: 'Confirm',
      message: 'Are you sure you want to update all Farmer errors / missing fields? This may take a while.',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            
          }
        }, {
          text: 'Yes',
          handler: async () => {
            const loading = await this.loadingController.create({
              message: 'Please wait...'
            });
            await loading.present();
            this.farmerSvc.updateFarmerProfileErrorFields(undefined).subscribe(async response => {
              loading.dismiss();
              const alert = await this.alertController.create({
                header: 'Success',
                message: 'All Farmer errors / missing fields have been updated',
                buttons: ['OK']
              });
              await alert.present();
            }, async (error) => {
              loading.dismiss();
              const alert = await this.alertController.create({
                header: 'ERROR',
                message: 'There was an issue updating all Farmer errors / missing fields. Please contact IT for assistance.',
                buttons: ['OK']
              });
              await alert.present();
            });
          }
        }
      ]
    });

    await alert.present();
  }

  async certificationScores() {
    const alert = await this.alertController.create({
      header: 'Confirm',
      message: 'Are you sure you want to update all Certification Scores? This may take a while.',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            
          }
        }, {
          text: 'Yes',
          handler: async () => {
            const loading = await this.loadingController.create({
              message: 'Please wait...'
            });
            await loading.present();
            this.certificationService.updateCertificationScores(undefined).subscribe(async response => {
              loading.dismiss();
              const alert = await this.alertController.create({
                header: 'Success',
                message: 'All Certification scores have been updated',
                buttons: ['OK']
              });
              await alert.present();
            }, async (error) => {
              loading.dismiss();
              const alert = await this.alertController.create({
                header: 'ERROR',
                message: 'There was an issue updating all Certification scores. Please contact IT for assistance.',
                buttons: ['OK']
              });
              await alert.present();
            });
          }
        }
      ]
    });

    await alert.present();
  }

  isInsideWorkHours() { // return false;
    let date = new Date(); // current time
    let hours = date.getHours();
    let day = date.getDay();
    let workDays = [ 1, 2, 3, 4, 5 ]; // Mon-Fri
    return workDays.includes( day ) && hours >= 9 && hours < 17;
  }

}
